import { render } from "./QuickAction.vue?vue&type=template&id=185dfe39&scoped=true"
import script from "./QuickAction.vue?vue&type=script&lang=js"
export * from "./QuickAction.vue?vue&type=script&lang=js"

import "./QuickAction.vue?vue&type=style&index=0&id=185dfe39&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185dfe39"]])

export default __exports__